// extracted by mini-css-extract-plugin
export var btn = "Subscribe-module--btn--ii2qj";